(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-slider-component')) {
    customElements.define('product-slider-component', class ProductSliderComponent extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector('[data-slider]');
        this.arrowLeft = this.querySelector('[data-arrow-left]');
        this.arrowRight = this.querySelector('[data-arrow-right]');
        this.pagination = this.querySelector('[data-pagination]');
        
        if (!this.slider) return;

        this.init();
      }

      init() {
        this.updateArrowState = this.updateArrowState.bind(this);
        this.slider.addEventListener('scroll', this.updateArrowState, { passive: true });
        this.arrowLeft.addEventListener('click', this.scrollTo.bind(this, 'previous'));
        this.arrowRight.addEventListener('click', this.scrollTo.bind(this, 'next'));
        
        const resizeObserver = new ResizeObserver(() => this.setupPagination());
        resizeObserver.observe(this.slider);

        this.setupPagination();
      }
      
      scrollTo(direction) {
        const cardWidth = this.slider.querySelector('.product-slider__card').offsetWidth;
        const scrollAmount = (cardWidth + parseInt(getComputedStyle(this.slider).gap)) * (direction === 'next' ? 1 : -1);
        this.slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }

      updateArrowState() {
        const { scrollLeft, scrollWidth, clientWidth } = this.slider;
        this.arrowLeft.disabled = scrollLeft <= 0;
        this.arrowRight.disabled = scrollLeft >= scrollWidth - clientWidth - 1;
        this.updateActivePagination();
      }
      
      setupPagination() {
        this.pagination.innerHTML = '';
        
        const cardWidth = this.slider.querySelector('.product-slider__card')?.offsetWidth;
        if (!cardWidth) return;

        this.totalPages = Math.round(this.slider.scrollWidth / this.slider.clientWidth);

        if (this.totalPages <= 1) return;

        for (let i = 0; i < this.totalPages; i++) {
          const button = document.createElement('button');
          button.className = 'product-slider__pagination-item';
          button.onclick = () => {
            this.slider.scrollTo({
              left: i * this.slider.clientWidth,
              behavior: 'smooth'
            });
          };
          this.pagination.appendChild(button);
        }
        this.updateActivePagination();
      }

      updateActivePagination() {
        if (!this.pagination.hasChildNodes()) return;
        const currentPage = Math.round(this.slider.scrollLeft / this.slider.clientWidth);
        this.pagination.querySelectorAll('button').forEach((button, index) => {
          button.classList.toggle('product-slider__pagination-item--active', index === currentPage);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
